/** student/sessions — HOOKS. */
import { useMutation, useQuery } from '@tanstack/react-query';
import { studentSessionsApi } from './api';
import { studentSessionsKeys } from './keys';

/**
 * The student's sessions, upcoming and past. Polls every 60s while the tab is
 * visible so status transitions surface, as the sessions page needs; `poll:
 * false` reads the list as any query does — on mount and on the tab's return —
 * and `enabled: false` not at all, as the home's Up Next reads it only for a
 * student with an ended campaign.
 */
export function useStudentSessions({ enabled = true, poll = true }: { enabled?: boolean; poll?: boolean } = {}) {
  return useQuery({
    queryKey: studentSessionsKeys.all(),
    queryFn: () => studentSessionsApi.fetchMySessions(),
    enabled,
    refetchInterval: poll ? 60_000 : false,
    refetchIntervalInBackground: false,
  });
}

/** Launches a live session — returns `{ launchUrl }` to open the game client. */
export function useLaunchSession() {
  return useMutation({
    mutationFn: (sessionId: string) => studentSessionsApi.launchSession(sessionId),
  });
}
